import { each, on } from '../helpers/shortcuts';
import shared from './shared';

export default () => {
  const items = document.querySelectorAll('.c-featured__item');

  if (items.length < 1) {
    return;
  }

  each(items, item => {
    const triggers = item.querySelectorAll('.js-trigger');

    on('click', triggers, event => {
      event.preventDefault();
      item.classList.toggle(shared.CSS.active);
    });
  });
};



// WEBPACK FOOTER //
// ./src/scripts/modules/featured.js